import { render, staticRenderFns } from "./cate-troubleshooting.vue?vue&type=template&id=156d9e3d"
import script from "./cate-troubleshooting.vue?vue&type=script&lang=js"
export * from "./cate-troubleshooting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports